import styled from 'styled-components';

export const Table = styled('table')`
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    th:first-child, td:first-child {
        padding-left: 0;
    }

    th, td{
        padding: 12px 15px;
        text-align: left;
        border-bottom: 1px solid #E1E1E1;
    }
`;
